// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1FULb","title":"FrontImage_title__2mwte"};